import { TriggerCondition } from '@augloop/interfaces';
/**
 * Return a value from the map if it exists.
 * If the value does not exists create a value using the factory method, add it to the map and return it.
 *
 * @param map Map to operate on.
 * @param key Key for lookup.
 * @param itemFactory Factory method that instantiates the value if it does not exist.
 */
export const getOrSetDefaultValue = (map, key, itemFactory) => {
    let item = map.get(key);
    if (!item) {
        item = itemFactory();
        map.set(key, item);
    }
    return item;
};
export const getWorkflowDefinitionBase = (workflow) => {
    return {
        id: workflow.id,
        kind: workflow.kind,
        visibility: workflow.visibility,
        collectionScopeType: workflow.collectionScopeType,
        inputTypes: workflow.inputTypes,
        outputTypes: workflow.outputTypes,
        correlatedSignals: workflow.correlatedSignals
    };
};
export const isHybridWorkflow = (workflow) => {
    return Array.isArray(workflow.correlatedSignals) && workflow.correlatedSignals.length > 0;
};
export const compareRevisions = (first, second) => {
    if (!first.revId || !second.revId || first.revId === second.revId) {
        return 0;
    }
    if (parseInt(first.revId, 10) > parseInt(second.revId, 10)) {
        return 1;
    }
    return -1;
};
export const isParentContextId = (parentContextId, childContextId) => {
    if (parentContextId === undefined || parentContextId === null) {
        return false;
    }
    if (childContextId === undefined || childContextId === null) {
        return false;
    }
    return parentContextId.length > 0 && (parentContextId === childContextId || (childContextId.indexOf(parentContextId) === 0 && childContextId.charAt(parentContextId.length) === '.'));
};
export const isSignalTriggeredWorkflow = (workflow) => {
    return Array.isArray(workflow.triggerSignals)
        && workflow.triggerSignals.length > 0;
};
export const isWorkflowTriggeredByNonExclusiveSignals = (workflow) => {
    var _a, _b;
    return (_b = (_a = workflow.triggerConditions) === null || _a === void 0 ? void 0 : _a.includes(TriggerCondition.NonExclusiveTriggerSignals)) !== null && _b !== void 0 ? _b : false;
};
//# sourceMappingURL=utils.js.map